<template>
  <modal name="burger-menu-modal" :width="1" :height="1" @before-open="onMenuOpen" @closed="onMenuClose">
    <div class="menu-bar left-side">
      <span class="menu-title">MENU</span>
      <nav class="menu-items mt-3">
        <div v-for="item in menuItems" :key="item.id" @click="closeMenu">
          <a v-if="item.isBanner" :href="item.bannerLink" target="_blank">
            <span>{{item.title || item.name}}</span>
          </a>
          <span v-else @click="goToCategory(item)" :class="{'menu-item-active' : isMenuItemActive(item)}">{{item.title || item.name}}</span>
        </div>
      </nav>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import { spinnakerApi } from '../js/SpinnakerApi.js'

export default {
  computed: mapState({
    activeCategory: (state) => state.navigation.activeCategory
  }),
  data () {
    return {
      menuItems: []
    }
  },
  async created () {
    this.menuItems = await spinnakerApi.getMenuCategories()
  },
  methods: {
    isActiveCategoryMarkAllowed () {
      return this.$route.path === '/'
    },
    isAnActiveCategory (category) {
      // Change also similar code in Tabs.isAnActiveCategory
      return this.activeCategory?.category?.id === category.id && this.isActiveCategoryMarkAllowed()
    },
    isAnActiveCategoryParent (category) {
      // Change also similar code in Tabs.isAnActiveCategoryParent
      return this.activeCategory?.category?.parentCategoryIds?.includes(category.id) && this.isActiveCategoryMarkAllowed()
    },
    isMenuItemActive (category) {
      // Change also similar code in Tabs.isTabActive
      let isActive = this.isAnActiveCategory(category)
      if (!isActive) {
        if (category.isMain) {
          // Special case when 'Home' has to be highlighted when going from promo carousel
          const isOtherAnActiveCategoryParent = this.menuItems.find(this.isAnActiveCategoryParent)
          isActive = !isOtherAnActiveCategoryParent && this.activeCategory?.isPromo
        } else {
          // If child category is displayed then tab of it's parent is highlighted
          const isOtherActive = this.menuItems.find(this.isAnActiveCategory)
          isActive = !isOtherActive && this.isAnActiveCategoryParent(category)
        }
      }
      return isActive
    },
    closeMenu () {
      console.info('BurgerMenu: closing...')
      this.$emit('closeMenu')
    },
    onMenuOpen () {
      this.$store.commit('muteNotifications')
    },
    onMenuClose () {
      this.$store.commit('unmuteNotifications')
    },
    goToCategory (categoryItem) {
      this.$store.commit('navigation/goToCategory', categoryItem)
    }
  }
}
</script>
